import { useEffect, useState } from "react";
import { toast } from "sonner";
import { useAdminApi } from "@/hooks/useAdminApi";
import { errMsg } from "@/lib/api";

export const UsersTab = () => {
  const call = useAdminApi();
  const [data, setData] = useState({ roles: [], users: [] });
  const load = () => call("get", "/users").then(setData);
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const change = async (uid, role) => {
    try { await call("patch", `/users/${uid}/role`, { role }); toast.success("Role updated"); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="rounded-lg border border-white/10 bg-[#0F1117] overflow-x-auto">
      <table className="w-full text-sm">
        <thead className="text-left text-gray-500 label-eyebrow"><tr><th className="p-3">User ID</th><th className="p-3">Role</th></tr></thead>
        <tbody>
          {data.users.map((u) => (
            <tr key={u.user_id} data-testid={`user-row-${u.user_id}`} className="border-t border-white/5">
              <td className="p-3 font-mono text-xs">{u.user_id}</td>
              <td className="p-3">
                <select data-testid={`user-role-select-${u.user_id}`} value={u.role} onChange={(e) => change(u.user_id, e.target.value)}
                  className="h-9 px-2 rounded-md bg-[#08090C] border border-white/10">
                  {data.roles.map((r) => <option key={r}>{r}</option>)}
                </select>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
